import { IGetBranchInput } from "../../../../api-schema/branch";

export const BRANCH_ENDPOINT = "branch";
export const buildBranchCacheKey = ({ bId }: IGetBranchInput) => [
  bId,
  BRANCH_ENDPOINT,
];
